/* import __COLOCATED_TEMPLATE__ from './advanced-settings-websync-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type ModalService from 'embercom/services/modal-service';
import type Store from '@ember-data/store';
import type ContentImportSource from 'embercom/models/content-service/content-import-source';
import type Folder from 'embercom/models/content-service/folder';

interface Signature {
  Args: {
    model: {
      contentImportSource: ContentImportSource;
      onSave: (formData: Record<string, unknown>) => Promise<void>;
      onSaveAndSync: (formData: Record<string, unknown>) => Promise<void>;
    };
  };
}

export default class AdvancedSettingsWebsyncSheet extends Component<Signature> {
  @service declare modalService: ModalService;
  @service declare store: Store;

  get folderTitle(): string | undefined {
    let folderId = this.args.model.contentImportSource.folderId;
    if (!folderId) {
      return undefined;
    }
    let folder = this.store.peekRecord('content-service/folder', folderId) as Folder | null;
    return folder?.name ?? undefined;
  }

  @action
  onOpenChange() {
    this.modalService.closeModal();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::KnowledgeHub::AdvancedSettingsWebsync::AdvancedSettingsWebsyncSheet': typeof AdvancedSettingsWebsyncSheet;
    'react/knowledge-hub/advanced-settings-websync/advanced-settings-websync-sheet': typeof AdvancedSettingsWebsyncSheet;
  }
}
